import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import EmptyState from '@atlaskit/empty-state';
import React from 'react';
import { injectIntl, type WrappedComponentProps } from 'react-intl-next';
import messages from './messages';
import ViewTracker from '../../../common/analytics/view-tracker';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/analytics-bridge';
import InlineJoinButton from '../inline-join-button/connected';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { N300 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Subtitle = styled.p({
	color: token('color.text.subtlest', N300),
	textAlign: 'center',
	marginTop: token('space.negative.300', '-24px'),
});

interface OwnProps {
	onClick: (e: React.MouseEvent, analyticsEvent: UIAnalyticsEvent) => void;
	renderHeroImage: () => React.ReactNode;
}

const InlineJoinProduct = injectIntl(
	({ intl: { formatMessage }, onClick, renderHeroImage }: OwnProps & WrappedComponentProps) => {
		return (
			<>
				<EmptyState
					renderImage={renderHeroImage}
					header={formatMessage(messages.joinProductTitle)}
					description={formatMessage(messages.joinProductDescription)}
					primaryAction={
						<InlineJoinButton onClick={onClick}>
							{formatMessage(messages.joinProductButton)}
						</InlineJoinButton>
					}
					testId="confluence-project-pages.cross-join.join-product"
				/>
				<Subtitle>
					<small>{formatMessage(messages.joinProductButtonDescription)}</small>
				</Subtitle>
				<ViewTracker />
			</>
		);
	},
);

export default (props: OwnProps) => (
	<ContextualAnalyticsData sourceName="projectPagesJoin" sourceType={SCREEN}>
		<InlineJoinProduct {...props} />
	</ContextualAnalyticsData>
);
